<template>
  <div class="section-samples">
    <b-row class="d-flex align-items-center mb-2 mt-1 px-2">
      <b-col>
        <span class="ap-title ap-title__main">{{ $tc('global.sample', 2) }}</span>
      </b-col>
      <b-col class="d-flex justify-content-end">
        <button
          v-tooltip="$tc('global.cleanFilter')"
          v-shortkey="['ctrl', 'alt', 'f']"
          type="button"
          class="btn btn__icon btn__icon--primary p-0 btn-secondary"
          @shortkey.prevent="cleanFilters"
          @click="cleanFilters"
        >
          <span class="far fa-filter" />
        </button>
        <vt-report-export-buttons
          source="global-search-sample-grid"
          :export-report="exportReport"
        />
      </b-col>
    </b-row>
    <b-row class="px-1">
      <b-col>
        <vt-grid
          v-if="statesLoaded"
          :row-data="samples"
          :grid-options="gridOptions"
          class="samples-grid"
          :column-defs="columnDefs"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VtGrid from '@/components/VtGrid/VtGrid'
import { sectionSampleGridColumnDefs } from '@/modules/globalLocatorModule/sections/sample/section-sample-sample.column-defs'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import sampleService from '@/api/resources/common/commonSampleService'
import { GridExportMixin } from '@/mixins/grid-export.mixin'
import { GridUtils } from '@/shared/util/grid-utils'
import { sampleState } from '@/api/resources/entityState/sample-state'
import { AgGridRowModelType } from '@/shared/models/ag-grid.model'

export default {
    name: 'SamplesSection',
    components: {
        VtGrid
    },
    mixins: [
        GridExportMixin
    ],
    props: {
        foundItem: String,
        laboratoryId: { type: Number, required: true },
        caseId: { type: Number, required: true }
    },
    data() {
        return {
            samples: [],
            columnDefs: sectionSampleGridColumnDefs,
            columnApi: null,
            statesLoaded: false
        }
    },
    computed: {
        gridOptions() {
            return {
                sideBar: gridSideBarConfig,
                rowModelType: AgGridRowModelType.CLIENT_SIDE,
                onGridReady: this.onGridReady,
                getRowStyle: (params) => {
                    if (params.data.sampleLabel === this.foundItem) {
                        return { background: '#CBF1E3 !important' }
                    }
                }
            }
        }
    },
    watch: {
        async caseId() {
            await this.loadSamples()
        }
    },
    async created() {
        await sampleState.loadStates()
        this.statesLoaded = true
    },
    methods: {
        cleanFilters() {
            this.gridApi.setFilterModel(null)
        },
        async onGridReady({ api }) {
            this.gridApi = api
            this.columnApi = api.columnModel
        },
        async loadSamples() {
            this.samples =
                await this.$_toCallSecure(
                    sampleService.getSamples(this.laboratoryId, this.caseId))
        },
        exportReport(exportType) {
            const columns = this.$_getColumnsToExport(this.gridApi, this.columnApi)
            if (columns && this.gridApi) {
                return sampleService.exportTo(
                    this.laboratoryId,
                    this.caseId,
                    this.foundItem,
                    this.gridApi.getFilterModel(),
                    GridUtils.getSortValue(this.gridApi.getSortModel()),
                    columns,
                    this.gridApi.getSelectedRows()?.map(sample => {
                        return sample?.id
                    }),
                    exportType)
            }
            return null
        }
    }
}
</script>

<style lang="scss" scoped>
  .samples-grid {
  height: calc(100vh - 350px) !important;
}

@media only screen and (max-width: 1366px) and (min-width: 1360px) {
   .samples-grid {
  height: calc(100vh - 290px) !important;
}
}

</style>

<style lang="scss">
.ag-status-bar{
  display: none;
}

</style>
